<template>
  <div class="d-flex justify-content-center bg-white vh-100">
    <!-- Mobile View Container -->
    <div class="d-flex flex-column bg-light w-100" style="height: 90vh">
      <!-- Fixed Top Navbar -->
      <div
        class="container-fluid fixed-top bg-light shadow-sm py-2 w-100"
       
      >
        <div class="d-flex flex-column align-items-center px-2">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <button
                class="btn bg-transparent p-0 me-2 mb-3"
                data-bs-toggle="modal"
                data-bs-target="#sidebarModal"
              >
                <i class="fas fa-list text-dark fs-4"></i>
              </button>
              <div>
                <p class="text-muted mb-0">Namaste</p>
                <p class="fw-semibold text-capitalize text-dark mb-0">
                  {{ name }} <span>ji</span>
                </p>
              </div>
            </div>
             <div class="my-2 text-center">
            <img
              src="/app/images/bloom-logo.png"
              style="width:20vw"
            />
          </div>
            <div class="bg-light rounded px-3 py-2 text-dark text-start">
              <div class="d-flex justify-content-between">
                <p class="fw-bold mb-0">{{id}}</p>
                <p class="mb-0 text-muted small">My Rank</p>
              </div>
              <div class="d-flex align-items-center gap-4">
                <p class="fw-bold mb-0">0</p>
                <p class="mb-0 text-muted small">Karma Points</p>
              </div>
            </div>
          </div>
         
        </div>
      </div>
      <!-- Main Content -->
      <div class="flex-grow-1 mt-5 pt-5 overflow-auto">
        <!-- White Container for Tabs -->
        <div class="container-fluid bg-white rounded shadow-sm p-1">
          <!-- Tab Navigation -->
          <div class="sticky-top bg-light py-3 z-20">
            <!-- Tab Navigation -->
            <ul
              class="nav nav-pills nav-justified bg-opacity-10 rounded p-1 mt-5"
              id="resourceTabs"
              role="tablist"
              style="background-color: #563328"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active text-white rounded fw-medium"
                  id="pdfs-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pdfs"
                  type="button"
                  role="tab"
                  aria-controls="pdfs"
                  aria-selected="true"
                >
                  PDFs
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  @click="fetchData"
                  class="nav-link text-white rounded fw-medium"
                  id="videos-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#videos"
                  type="button"
                  role="tab"
                  aria-controls="videos"
                  aria-selected="false"
                >
                  VIDEOS
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link text-white rounded fw-medium"
                  id="faqs-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#faqs"
                  type="button"
                  role="tab"
                  aria-controls="faqs"
                  aria-selected="false"
                >
                  FAQs
                </button>
              </li>
            </ul>

            <!-- Tab Content -->
            <div class="tab-content mt-3">
              <div
                class="tab-pane fade show active"
                id="pdfs"
                role="tabpanel"
                aria-labelledby="pdfs-tab"
              >
                <div class="p-0 bg-white rounded shadow-sm">
                  <!-- PDF Card -->
                  <div class="my-4">
                    <div
                      v-for="(item, index) in pdfList"
                      :key="index"
                      class="d-flex gap-3 p-3 shadow-lg rounded bg-white align-items-center"
                      role="button"
                    >
                      <!-- Image Section -->
                      <div class="flex-shrink-0" style="max-width: 25%">
                        <img
                          :src="item.image"
                          class="img-fluid rounded"
                          alt="Yoga Handbook"
                        />
                      </div>

                      <!-- Text Content Section -->
                      <div
                        class="d-flex flex-column container-fluid justify-content-between"
                      >
                        <!--  <p class="mb-1 text-dark fw-medium">
                          Yoga Handbook <br />
                          <span class="text-muted small">55+ ASANAS</span>
                        </p> -->
                        <p class="mb-2 text-muted small">
                          {{ item.description }}
                        </p>

                        <!-- Download Button -->
                        <div class="text-end">
                          <a
                            :href="item.url"
                            target="_blank"
                            class="btn text-white rounded-pill"
                            style="background-color: #ff7345"
                            download
                          >
                            <i class="fas fa-download"></i> Download
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  class="tab-pane fade"
                id="videos"
                role="tabpanel"
                aria-labelledby="videos-tab">
 <div
              v-if="UserValidity"
               
              >
                <div class="position-relative d-flex align-items-center mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    class="position-absolute ms-3 text-secondary"
                    style="width: 24px; height: 24px"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    ></path>
                  </svg>
                  <input
                    type="text"
                    class="form-control ps-5 py-2 rounded-pill border-secondary"
                    v-model="search"
                    @keyup="searchResult"
                    placeholder="Search"
                  />
                </div>

                <!-- Filters Heading -->
                <h3 class="text-dark fw-medium mb-2">Filters</h3>

                <!-- Filter Buttons -->
                <div class="d-flex flex-row overflow-auto">

                  <button class="btn btn-secondary me-1" @click="filterCat('All')">
                    All
                  </button>
                  <button
                   v-for="(item, index) in categoryList"
                      :key="index"
                    class="btn btn-outline-secondary me-1"
                    @click="filterCat(item)"
                  >
                    {{item}}
                  </button>
                </div>
                <div class="mt-4">
                  <h2 class="fs-5 text-dark fw-medium">Popular Videos</h2>
                </div>
                <!-- Video Content -->
                
                <div v-if="videoList?.popularVideos?.length==0">
                  No records found
                </div>
                <div>
                  <div class="mt-3" style="height:330px" :style="{ 'overflow-y': showMore ? 'hidden' : 'scroll' }">
                    <div
                      class="card shadow-sm mb-2"
                      v-for="(item, index) in videoList && videoList.popularVideos"
                      :key="index"
                      role="button"
                    >
                      <div
                        class="d-flex align-items-center gap-2"
                        data-bs-toggle="modal"
                        @click="video = item"
                        data-bs-target="#exampleModal"
                      >
                        <img
                          :src="item.image"
                          class="img-fluid rounded-start"
                          style="width: 120px; height: 100px; object-fit: contain"
                          alt="Video Thumbnail"
                        />
                        <p class="text-dark fw-medium mb-0">
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                </div>
                <div  v-if="showMore && videoList?.popularVideos?.length !==0 " @click=" showMore = false"
                  class="d-flex align-items-center justify-content-center mt-2 text-primary fw-medium cursor-pointer"
                >
                  <i class="fas fa-chevron-down me-1 mt-1"></i>
                  <span>See All</span>
                </div>
                  
                   </div>



                <div class="mt-5">
                  <h2 class="fs-5 fw-medium text-dark">All Videos</h2>
                </div>
                <div v-if="videoList?.categoryVideos?.length==0">
                  No records found
                </div>
                <div
                  class="card shadow-sm mb-2"
                  v-for="(item, index) in videoList && videoList.categoryVideos"
                  :key="index"
                  role="button"
                >
                  <div
                    class="d-flex align-items-center gap-2"
                    data-bs-toggle="modal"
                    @click="video = item"
                    data-bs-target="#exampleModal"
                  >
                    <img
                      :src="item.image"
                      class="img-fluid rounded-start"
                      style="width: 120px; height: 100px; object-fit: contain"
                      alt="Video Thumbnail"
                    />

                    <p class="text-dark fw-medium mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>
              
              <div v-if="!UserValidity">
                Please update the plan to watch the video
              </div>

              </div>
             


              <div
                class="tab-pane fade"
                id="faqs"
                role="tabpanel"
                aria-labelledby="faqs-tab"
              >
                <div class="accordion" id="faqAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        How can I join the sessions?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#faqAccordion"
                    >
                      <div class="accordion-body">
                        The joining link for all the sessions will be the same:
                        https://habit.yoga/live
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How to access dashboard?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#faqAccordion"
                    >
                      <div class="accordion-body">
                        https://www.youtube.com/watch?v=qMeazzVQrGw
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What language will be used in the sessions?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#faqAccordion"
                    >
                      <div class="accordion-body">
                        The sessions will be held in a mix of English and Hindi languages.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        What are the batch timings?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#faqAccordion"
                    >
                      <div class="accordion-body">
                        We have six batches -<br />
                        Morning<br />
                        1. 6:30 -7:15 AM<br />
                        2. 7:30 -8:15 AM<br />
                        3. 8:30 - 9:15 AM<br />

                        Evening<br />
                        1. 5:00 -5:45 PM<br />
                        2. 6:00 -6:45 PM<br />
                        3. 7:00 -7:45 PM<br />
                        Please note all timings are in IST.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Ensure Bootstrap JavaScript is included -->

          <!-- Fixed Bottom Navbar -->
           <div
          class="container-fluid fixed-bottom bg-white shadow-lg w-100"
          
        >
          <div class="d-flex justify-content-around py-3">
            <router-link to="/dashboard" class="text-decoration-none text-center blkClr">
              <div class="bg-opacity-10 rounded-circle d-inline-block">
                <i class="fas fa-home fs-5" ></i>
              </div>
              <p class="mb-0 small fw-semibold">Home</p>
            </router-link>
            <router-link to="/resources" class="text-decoration-none text-center">
              <i class="fas fa-book fs-5 d-block" style="color: #ff7345"></i>
              <p class="mb-0 small fw-semibold " style="color: #ff7345" >Resources</p>
            </router-link>
            <a class="text-muted text-decoration-none text-center" href="/referals">
              <i class="fas fa-users fs-5 d-block"></i>
              <p class="mb-0 small fw-semibold">My Referral</p>
            </a>
            <router-link
                    to="/login"
                    class="text-decoration-none text-center  blkClr"
                  >
                  <div class="bg-opacity-10 rounded-circle d-inline-block">
                <i class="fas fa-sign-out-alt" ></i>
              </div>
              <p class="mb-0 small fw-semibold">Logout</p>
                  </router-link>
          </div>
        </div>

          <div
            class="modal fade"
            id="sidebarModal"
            tabindex="-1"
            aria-labelledby="sidebarModalLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div
              class="modal-dialog modal-fullscreen modal-dialog-start w-100"
             
            >
              <div class="modal-content">
                <div class="modal-body text-center">
                  <div class="text-end">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <!-- Profile Icon -->
                    <i class="fas fa-user-circle fa-3x mb-4"></i>

                    <!-- Profile Info -->
                    <div>
                      <p class="fw-semibold text-start fs-5">
                        {{name}}<br />
                        <!-- <span class="text-dark fw-medium me-1 fs-6">
                          View Profile
                          <i class="fas fa-chevron-right"></i
                        ></span> -->
                      </p>
                    </div>
                  </div>

                <!--   <div class="card text-center shadow-lg p-3 bg-light">
                    <h5>Personal Invite QR Code</h5>
                    <p>
                      Ask Your Friends to scan and gift<br />14 Days of FREE ONLINE YOGA
                    </p>
                    <img
                      src="/app/images/qr-code.png"
                      width="200"
                      height="200"
                      class="ms-4"
                    />
                  </div>
                  <div class="text-center">
                    <button
                      class="btn text-white d-flex justify-content-center align-items-center gap-2 mt-3 mb-3 ms-5"
                      style="background-color: #ff7345"
                    >
                      <i class="fas fa-download"></i> Download QR
                    </button>
                  </div> -->
                  <div class="text-start">
                    <p><i class="fas fa-question-circle"></i> FAQ'S</p>
                    <router-link
                    to="/login"
                    class="text-decoration-none text-center"
                  >
                    <p class="text-start" data-bs-dismiss="modal"><i class="fas fa-sign-out-alt"></i> Logout</p>
                  </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of Mobile View Container -->
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-fullscreen-xx p-0 m-0">
      <div class="modal-content" style="width: 100vw; height: 100vh">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ video.description }}</h5>
          <button
            type="button"
            class="btn-close"
            @click="video = {}"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <iframe
            :key="video.url"
            width="100%"
            height="100%"
            :src="`${video.url}?rel=0&amp;autoplay=1`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed, watch  } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  setup() {
    const videoList = ref(null);
    const pdfList = ref(null);
    const videoListAll = ref(null);
    const categoryList = ref(null);
    const pdfListAll = ref(null);
    const video = ref(false);
    const category = ref(false);
    const popular = ref(false);
    const store = useStore();
     const router = useRouter();
    const search = ref('');
    const showMore = ref(true);
    const name = computed(() => store.state.profile);
      const UserValidity = computed(() => store.state.validity);
    const filterCat = (val) => {
      category.value = val;
      fetchData();
    };
    const token = computed(() => store.state.user.token);
    const id = computed(() => store.state.user.id);
   const searchResult = () => {
  // Initialize videoListAll and pdfListAll if they are null or undefined
  if (!videoListAll.value) {
    videoListAll.value = JSON.parse(JSON.stringify(videoList.value));
  }

  // Ensure videoListAll.value has the necessary properties
  if (videoListAll.value && videoListAll.value.categoryVideos) {
    videoList.value.categoryVideos = videoListAll.value.categoryVideos.filter(item =>
      item.description.toLowerCase().includes(search.value.toLowerCase())
    );
  } else {
    videoList.value.categoryVideos = [];
  }

  if (videoListAll.value && videoListAll.value.popularVideos) {
    videoList.value.popularVideos = videoListAll.value.popularVideos.filter(item =>
      item.description.toLowerCase().includes(search.value.toLowerCase())
    );
  } else {
    videoList.value.popularVideos = [];
  }

  
};
  const checkAuth = () => {
      if (!token.value) {
        router.push("/login");
        return false;
      }
      return true;
    };
const categoriesInitialized = ref(false);
    const fetchData = async () => {
      if (!checkAuth()) return;
      try {
        let query = "";
        if (category.value) {
          query += (query ? "&" : "?") + "category=" + encodeURIComponent(category.value);
        }
        if (popular.value) {
          query += (query ? "&" : "?") + "popular=" + encodeURIComponent(popular.value);
        }
        [videoList.value, pdfList.value] = await Promise.all([
          fetch(`${process.env.VUE_APP_API_URL}videos/list` + query).then((res) =>
        
            res.json()
          ),
          fetch(`${process.env.VUE_APP_API_URL}pdfs/list`).then((res) => res.json()),
        ]);

          if (!categoriesInitialized.value && videoList.value && videoList.value.categoryVideos) {
      categoryList.value = [...new Set(videoList.value.categoryVideos.map(item => item.category))];
      categoriesInitialized.value = true;
    }
     
      } catch (err) {
        // error.value = `Failed to fetch users: ${err.message}`;
      } finally {
        // loading.value = false; // Stop the loading spinner
      }
    };
     watch(token, (newToken) => {
      if (!newToken) {
        router.push("/login");
      }
    });
      onMounted(() => {
      checkAuth();
      fetchData();
    });
    return {
      videoList,
      pdfList,
      video,
      name,
      filterCat,
      search,
      videoListAll,
      pdfListAll,
      searchResult,
      showMore,
      categoryList,
      token,
      UserValidity,
      id
    };
  },
};
</script>
<style>
.blkClr {
  color: var(--bs-secondary-color) !important;
}
</style>
